import React, { useCallback, useRef } from 'react';

import { useIntl } from 'react-intl-next';

import DropdownMenu, { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { RovoIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags';
import {
	ExperienceName,
	useAIMateExperienceTracker,
} from '@atlassian/conversation-assistant-instrumentation';
import { ModalDropdownItemTrigger } from '@atlassian/entry-point-modal-trigger/ModalDropdownItemTrigger';

import { jiraSmartCreationEntrypoint } from './entrypoint';
import { messages } from './messages';
import type { ConversationConfig } from './modal/types';

const DATA_TEST_ID = 'jira-smart-creation.ui.create-with-ai.dropdown';

export const CreateWithAIDropdown = (props: ConversationConfig): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const experienceTracker = useAIMateExperienceTracker();
	const returnFocusRef = useRef<HTMLElement>(null);

	const handleOpenChange = useCallback(
		({ isOpen }: { isOpen: boolean }) => {
			if (isOpen) {
				experienceTracker.start({
					name: ExperienceName.AIFC_LOAD_STAGING_AREA_MODAL,
					id: ExperienceName.AIFC_LOAD_STAGING_AREA_MODAL,
					attributes: {
						product: 'jira',
					},
				});
			}
		},
		[experienceTracker],
	);

	return (
		<DropdownMenu
			testId={DATA_TEST_ID}
			onOpenChange={handleOpenChange}
			returnFocusRef={returnFocusRef}
			label={
				fg('blu-8547_fix_a11y_violation_button_name_nav')
					? formatMessage(messages.dropdownLabel)
					: undefined
			}
		>
			<DropdownItemGroup>
				<ModalDropdownItemTrigger
					entryPoint={jiraSmartCreationEntrypoint}
					entryPointProps={props}
					elemBefore={<RovoIcon size="xsmall" />}
				>
					{formatMessage(messages.createWithAIItem)}
				</ModalDropdownItemTrigger>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
